var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-69.7852 158.526C-69.7852 158.526 117.215 158.611 151.729 158.611C147.785 183.291 134.014 216.152 124.754 230.04C126.364 230.829 128.331 231.926 129.723 232.939C148.44 208.702 229.097 138.598 289.788 120.723V115.276C229.098 97.3971 148.442 27.2964 129.723 3.0614C128.331 4.07371 126.366 5.16929 124.754 5.95464C134.015 19.8461 147.785 52.7069 151.729 77.3844C117.215 77.3844 -69.7852 77.4709 -69.7852 77.4709V158.526V158.526Z","stroke":"#FFF200","strokeWidth":"2.72","strokeMiterlimit":"10"}));
}

Arrow.defaultProps = {"width":"292","height":"236","viewBox":"0 0 292 236","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
